import styled from "@emotion/styled";

export const WrapperTable = styled.div`
  margin-top: 24px;
`;
